export { default as LifestylesAuthorsFilterBadge } from './LifestylesAuthorsFilterBadge';
